module.exports = __webpack_public_path__ + "img/project3.1c49dc96.png";